export default __webpack_public_path__ + "static/media/reciept.4c8efb65.jpeg";